const useMagneticScanner = JSON.parse(localStorage.getItem('useMagneticScanner')) == null ? true : JSON.parse(localStorage.getItem('useMagneticScanner'))
const showImages = JSON.parse(localStorage.getItem('showImages'))
const businessDay = JSON.parse(localStorage.getItem('businessDay'))
const legalAge = JSON.parse(localStorage.getItem('legalAge'))
const printers = JSON.parse(localStorage.getItem('printers'))
const selectedPrinterPM = JSON.parse(localStorage.getItem('selectedPrinterPM'))
const limitAlcoholPerDay = JSON.parse(localStorage.getItem('limitAlcoholPerDay'))
const logoutOnChitPrint = JSON.parse(localStorage.getItem('logoutOnChitPrint'))
const activeTax = JSON.parse(localStorage.getItem('activeTax'))

const initialState = {
	selectedPrinterPM: selectedPrinterPM,
	useMagneticScanner: useMagneticScanner,
	showImages: showImages, 
	businessDay: businessDay,
	legalAge: legalAge,
	printers: printers,
	limitAlcoholPerDay: limitAlcoholPerDay,
	logoutOnChitPrint: logoutOnChitPrint,
	activeTax: activeTax,
	guestFlowActive: false,
}

export const settings = {
	namespace: true,
	state: initialState,

	getters: {
		limitAlcoholPerDay(state) {
			return state.limitAlcoholPerDay;
		},

		logoutOnChitPrint(state) {
			return state?.logoutOnChitPrint;
		},

		legalAge(state) {
			return state.legalAge;
		},

		activeTax(state) {
			return state?.activeTax ?? null;
		},
	},

	actions: {
		setSelectedPrinterPM({commit}, data) {
			localStorage.setItem('selectedPrinterPM', JSON.stringify(data));
			commit('SET_SELECTED_PRINTER_PM', data);
		},
		setUseMagneticScanner({commit}, data) {
			localStorage.setItem('useMagneticScanner', JSON.stringify(data));
			commit('SET_MAGNETIC_SCANNER', data);
		},
		setShowImages({commit}, data) {
			localStorage.setItem('showImages', JSON.stringify(data));
			commit('SET_SHOW_IMAGES', data);
		},
		setBusinessDay({commit}, data) {
			localStorage.setItem('businessDay', JSON.stringify(data));
			commit('SET_BUSINESS_DAY', data);
		},
		setLegalAge({commit}, data) {
			commit('SET_LEGAL_AGE', data);
		},
		setPrinters({commit}, data) {
			commit('SET_PRINTERS', data);
		},
		setLimitAlcoholPerDay({commit}, data) {
			commit('SET_LIMIT_ALCOHOL_PER_DAY', data);
		},
		setLogoutOnChitPrint({commit}, data) {
			commit('SET_LOGOUT_ON_CHIT_PRINT', data);
		},
		setActiveTax({ commit }, data) {
			localStorage.setItem('activeTax', JSON.stringify(data));
			commit('SET_ACTIVE_TAX', data);
		},
		setGuestFlowActive({commit}, active) {
			commit('SET_GUEST_FLOW_ACTIVE', active);
		},
	},
	mutations: {
		SET_SELECTED_PRINTER_PM(state, data) {
			state.selectedPrinterPM = data;
		},
		SET_MAGNETIC_SCANNER(state, data) {
			state.useMagneticScanner = data;
		},
		SET_SHOW_IMAGES(state, data) {
			state.showImages = data;
		},
		SET_BUSINESS_DAY(state, data) {
			state.businessDay = data;
		},
		SET_LEGAL_AGE(state, data) {
			let la = {
				ADDITION_LEGAL_AGE_TABACCO: 0, 
				ADDITION_LEGAL_AGE_ALCOHOL: 0,
			};
			data.forEach((o) => {
				la[o.key] = +o.value;
			});
			state.legalAge = la;
			localStorage.setItem('legalAge', JSON.stringify(state.legalAge));
		},
		SET_PRINTERS(state, data) {
			state.printers = data;
			localStorage.setItem('printers', JSON.stringify(state.printers));
		},
		SET_LIMIT_ALCOHOL_PER_DAY(state, data) {
			state.limitAlcoholPerDay = data;
			localStorage.setItem('limitAlcoholPerDay', state.limitAlcoholPerDay?.toString());
		},
		SET_LOGOUT_ON_CHIT_PRINT(state, data) {
			state.logoutOnChitPrint = data;
			localStorage.setItem('logoutOnChitPrint', state.logoutOnChitPrint?.toString());
		},
		SET_ACTIVE_TAX(state, data) {
			state.activeTax = data;
		},
		SET_GUEST_FLOW_ACTIVE(state, active) {
			state.guestFlowActive = active;
		},
	}
}
